import axios from "axios";
import { api } from "./apiConfig";
import { CURRENT_APP, CURRENT_VERSION } from "../main"
import { translateString } from "./utils";



axios.defaults.baseURL = api

// 创建一个axios实例
const service = axios.create({
  baseURL: api,
  withCredentials: true,
  timeout: 30000
});

// 添加请求拦截器
service.interceptors.request.use(config => {
  let token = CURRENT_APP().$store.getters.getToken
  let project = CURRENT_APP().$store.getters.getProjectId
  if (token != undefined && token) {
    // 让每个请求携带自定义token 请根据实际情况自行修改
    config.headers["Authorization"] = "jwt " + token;
  }
  if (project != undefined && project) {
    // 让每个请求携带project
    config.headers["Project"] = project;
  }

  return config;
}, error => {
  // 请求错误
  return Promise.reject(error);
});

// 添加响应拦截器
service.interceptors.response.use(res => {
  let version = res.data.ver
  if (version && CURRENT_VERSION() != version) {
    CURRENT_APP().$confirm('发现新版本，当前页面存在缓存，请按ctrl+F5清理缓存！', '提示', {
      confirmButtonText: '确定',
      showCancelButton: false,
      type: 'warning'
    }).then(() => {
    }).catch(() => {
    });

    return Promise.reject(new Error("清理缓存"));
  }

  if (res.status == 200 && res.data.code == 200) {
    // 请求内容正确
    return res.data
  }
  else {
    if (res.status != 200) {
      return Promise.reject(new Error(translateString("网络异常，请检查网络")));
    }
    else {
      if (res.data.code == 401 || res.data.code == 410) {
        CURRENT_APP().$message.error(translateString(res.data.msg));

        // token失效或项目、用户有效期过期，则退出登录，删除token和project
        localStorage.removeItem("token")
        CURRENT_APP().$store.dispatch("setToken", "")

        localStorage.removeItem("project")
        CURRENT_APP().$store.dispatch("setProjectId", null)

        if (CURRENT_APP().$route.name != "login") {
          CURRENT_APP().$router.push({ name: "login" })
        }
      }
      
      if (res.data.type == "application/octet-stream") {
        return res.data
      }
      
      return Promise.reject(new Error(translateString(res.data.msg)));
    }
  }

}, error => {
  return Promise.reject(error);
});

export default service;


// WEBPACK FOOTER //
// ./src/utils/request.js